import React from 'react';

import { TopTournamentsCategoryProvider, useSportState } from '@atlas/core';

import PrematchPageViewDefiner from './PrematchPageViewDefiner';

const Prematch = () => {
  const { categories, id } = useSportState();

  return (
    <TopTournamentsCategoryProvider sportId={id}>
      <PrematchPageViewDefiner categories={categories} />
    </TopTournamentsCategoryProvider>
  );
};

export default Prematch;
